import { loadEnv } from '../../shims/load-env';

export const MINIMAX_API_KEY_ENV_VARIABLE_NAME = 'MINIMAX_API_KEY';
export const MINIMAX_BASE_URL_ENV_VARIABLE_NAME = 'MINIMAX_BASE_URL';
export const MINIMAX_DEFAULT_MODEL_ENV_VARIABLE_NAME = 'MINIMAX_DEFAULT_MODEL';

export const DEFAULT_MINIMAX_BASE_URL = 'https://api.minimaxi.com/anthropic';
export const DEFAULT_MINIMAX_MODEL = 'MiniMax-M3';

export function getDefaultMiniMaxKey(): string | undefined {
  return loadEnv()[MINIMAX_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultMiniMaxBaseURL(): string {
  return (
    loadEnv()[MINIMAX_BASE_URL_ENV_VARIABLE_NAME] ?? DEFAULT_MINIMAX_BASE_URL
  );
}

export function getDefaultMiniMaxModel(): string {
  return (
    loadEnv()[MINIMAX_DEFAULT_MODEL_ENV_VARIABLE_NAME] ?? DEFAULT_MINIMAX_MODEL
  );
}
